import { IMenuItem } from '../../models/menu.model';

/**
 * Menu configuration for Visitor Desk.
 * Contains menu items for receiving visitors, managing notifications, and reports.
 */
export const visitorDeskMenu: IMenuItem = {
  label: `Visitor Desk`,
  path: `visitor-desk`,
  id: 'MID_VISITOR_DESK',
  icon: 'fa fa-user-clock',
  children: [
    { path: `notifications`, label: `Visitor Notifications`, id: 'MID_VISITOR_NOTIFICATIONS' },
    { path: `receive-visitor`, label: `Receive Visitor`, id: 'MID_VISITOR_RECEIVE' },
    { path: `exit-visitor`, label: `Exit Visitor`, id: 'MID_VISITOR_EXIT' },
    { path: `visitors-report`, label: `Visitors Report`, id: 'MID_VISITOR_REPORT' },
  ],
};
